mutation Inertia_DestroyDocument($documentId: ID!) {
  destroyDocument(input: { documentId: $documentId }) {
    success
    errors
  }
}